import p5 from "p5";

const sketch = (p: p5) => {
    const fr = 60;

    p.setup = () => {
        p.frameRate(fr);
        // p.createCanvas(p.windowWidth, p.windowHeight - 52)
        p.createCanvas(window.innerWidth, window.innerHeight - 52);
    };


    let frs = 60;

    let paletas = [[200, 255, 128], [128, 200, 255]];
    let nPaleta = 0;

    p.draw = () => {
        if (!p.mouseIsPressed) {
            p.background(0, 0, 0, 10);
            if (p.frameCount % fr === 1) {
                p.background("#000");
            }
        }
        p.noStroke();

        let period = frs * 0.25;

        if (p.frameCount % fr === 0) nPaleta = (nPaleta + 1) % paletas.length;

        if (p.frameCount % frs < frs * 0.25 || (p.mouseIsPressed && p.frameCount % 2 === 0)) {
            for (let i = 0; i < period; i++) {
                p.fill(
                    p.color(
                        paletas[nPaleta][0] - Math.random() * 32,
                        paletas[nPaleta][1] - Math.random() * 127,
                        paletas[nPaleta][2] - Math.random() * 32
                    )
                );

                let j = Math.pow(Math.random(), 7);
                let k = Math.random() * 2 * Math.PI;
                let l = Math.pow(Math.random(), 7);

                p.ellipse(
                    p.mouseX + Math.sin(k) * (128 - j * 96),
                    p.mouseY + Math.cos(k) * (128 - l * 96),
                    Math.exp(Math.log(48) * (1 - (p.frameCount % period) / (period - 1))),
                    Math.exp(Math.log(24) * (1 - (p.frameCount % period) / (period - 1)))
                );
            }
        }
    };

    p.windowResized = () => {
        p.resizeCanvas(p.windowWidth, p.windowHeight - 52);
    };
};

export default sketch;
